module.exports = __webpack_public_path__ + "media/images/front/top/3-ba0d3502abd7f59def431af8e0c804eb.jpg";